<template>
    <div>
        <topback :title="name" path="back"></topback>
        <div class="newdetail" v-html="this.newdetail"></div>
    </div>
</template>

<script>
import topback from '@/components/topback'
import { getnewsIddetail, getnewsCodedetail } from '@/request/api'
export default {
    name: "Newdetail",
    components: {
        topback,
    },
    data() {
        return {
            name: "News",
            newdetail: "",
        }
    },
    created() {
        let code = this.$route.params.code;
        this.$toast.loading('Loading...');
        if(code) {
            getnewsCodedetail(code).then(res => {
                this.$toast.hide();
                if (res.code === 200) {
                    this.newdetail = res.data.content;
                    this.name = "News";
                }
            })
        } else {
            getnewsIddetail(this.$route.params.id).then(res => {
                this.$toast.hide();
                if (res.code === 200) {
                    this.newdetail = res.data.content;
                    this.name = "News";
                }
            });
        }
        
    },
}
</script>
<style scoped>
.newdetail {
    margin: 1rem 0;
    font-size: 0.5rem;
}
</style>
  


// WEBPACK FOOTER //
// src/components/newdetail.vue